import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnAD: CultureInfo = {
  name: 'en-AD',
  displayName: 'English (Andorra)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-AD',
  parent: CultureInfoEn
};
